import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var Copy = /*#__PURE__*/_styled("div", true ? {
  target: "e1tugjmz0"
} : {
  target: "e1tugjmz0",
  label: "Copy"
})(true ? {
  name: "budh8k",
  styles: "display:flex;flex-direction:column;gap:16px"
} : {
  name: "budh8k",
  styles: "display:flex;flex-direction:column;gap:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvQ2FyZC9Db3B5L0NvcHkudmlld3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRThCIiwiZmlsZSI6Ii93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvQ2FyZC9Db3B5L0NvcHkudmlld3MudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuZXhwb3J0IGNvbnN0IENvcHkgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBnYXA6IDE2cHg7XG5gXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});